import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "./http";
import { resetSettlementCacheForVersion } from "@/utils/cacheInvalidation";
import { claimInspector } from "@/services/claimInspector";

import "@mdi/font/css/materialdesignicons.css";
import "@/assets/styles/vercel-design-system.scss";

Vue.config.productionTip = false;

Vue.prototype.$axios = axios;

declare global {
  interface Window {
    claimInspector: typeof claimInspector;
    stClaims: typeof claimInspector;
    inspectClaimOrders: typeof claimInspector.inspectClaimOrders;
    getClaimOrders: typeof claimInspector.inspectClaimOrders;
  }
}

if (typeof window !== "undefined") {
  window.claimInspector = claimInspector;
  window.stClaims = claimInspector;
  window.inspectClaimOrders =
    claimInspector.inspectClaimOrders.bind(claimInspector);
  window.getClaimOrders =
    claimInspector.inspectClaimOrders.bind(claimInspector);
  console.log(
    "%c[ClaimInspector Ready] 콘솔에서 inspectClaimOrders('YYYY-MM-DD') 또는 claimInspector.help() 를 입력하여 명령어 안내를 확인하세요.",
    "color: #0070f3; font-weight: bold;"
  );
}

async function bootstrap() {
  try {
    await resetSettlementCacheForVersion();
  } catch (error) {
    // IndexedDB failure must not prevent the admin from starting.
    console.error("Failed to reset the settlement database cache:", error);
  }

  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}

bootstrap();
